import { createHttpRouteInvoker } from '../../../../../shared/backend/transports/http';
import { backendConfig } from '../config';
import { normalizeApiError } from '../errors';
import { firebase } from '@/lib/firebaseConfig';

export const invokeHttpRoute = createHttpRouteInvoker({
  apiBaseUrl: backendConfig.apiBaseUrl,
  getIdToken: async () => firebase.auth.currentUser?.getIdToken(),
  normalizeApiError,
});
